module.exports = __webpack_public_path__ + "./assets/features_hero_image.jpg";